import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {AVAILABLE_LANGUAGES, POST_MESSAGES} from "../../constants/dashboard";
import {setLanguage} from "../../actions/dashboardFunctions";

const LanguageSwitcher = (props) => {

  const {language, setLanguage, intl} = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const activeLanguage = language;

  useEffect(() => {
    window.addEventListener("message", messageListening);
    return () => {
      window.removeEventListener("click", handleWrapperBlur);
      window.removeEventListener("message", messageListening);
    }
  }, []);

  const handleWrapperBlur = (e) => {
    const disallowClasses = [".language", ".central-hub-dropdown"];
    if (!disallowClasses.some(cls => e.target.closest(cls))) {
      setDropdownVisible(false)
    }
  };

  const messageListening = (event) => {
    if (event && event.data && event.data.action === POST_MESSAGES.setIframeLanguage) {
      setLanguage(event.data.payload.language)
    }
  };

  const handleButtonClick = () => {
    const newVisible = !dropdownVisible;
    setDropdownVisible(newVisible);
    setTimeout(() => {
      newVisible
        ? window.addEventListener('click', handleWrapperBlur)
        : window.removeEventListener('click', handleWrapperBlur)
    }, 0)
  };

  const handleLocaleClick = (locale) => {
    setLanguage(locale);
    handleButtonClick();
  };

  const getLanguageName = (locale) => {
    switch (locale) {
      case "en-US":
        return intl.formatMessage({id: "languageDropdown.english"})
      case "en-AU":
        return intl.formatMessage({id: "languageDropdown.australian"})
      case "fr-FR":
        return intl.formatMessage({id: "languageDropdown.french"})
      case "pl-PL":
        return intl.formatMessage({id: "languageDropdown.polish"})
      case "es-ES":
        return intl.formatMessage({id: "languageDropdown.spanish"})
      default:
        return locale
    }
  };

  const styles = {
    height: dropdownVisible ? AVAILABLE_LANGUAGES.length * 50 : 0
  }

  return (
    <div className="language">
      <button className={"central-hub-language-icon" + (dropdownVisible ? " materials-button--active" : "")}
              onClick={handleButtonClick}>
        <div className="central-hub-icon-desc">Language</div>
      </button>
      <div className={"central-hub-dropdown" + (dropdownVisible ? " central-hub-dropdown--visible" : "")} style={styles}>
        <ul className="central-hub-dropdown__list ui-list">
          {AVAILABLE_LANGUAGES.map((locale, languageIndex) => (
            <li className={"central-hub-dropdown__list-item" + (activeLanguage === locale ? " central-hub-dropdown__list-item--active" : "")}
                key={languageIndex}
                onClick={() => handleLocaleClick(locale)}>
              {getLanguageName(locale)}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    language: store.dashboardState.language,
  };
};

const mapDispatchToProps = {
  setLanguage
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher)
);
